import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import s from './s.module.less';
import { useParams, useNavigate } from 'react-router-dom';
import commonS from 'styles/common.module.less';
import { Spin, Button, message, Modal, Alert, Space, Radio, Checkbox, Col, Row, Input } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import {
    updateProviderChannelInfo,
    // providerChannelAuditGoLive,
    channelWaitingApproval,
    updateUniprofileAuditStatus,
    syncSnapshot,
    syncEhr,
    getEhrInitStatus,
    // exportProviderByPorivderId,
    updateLaunchTime,
    emailProvider,
} from 'api/operation';
import OnHoldImg from 'assets/operation/sendFeedback.png';
import ApproveImg from 'assets/operation/approve.png';
import Motivation from 'assets/operation/motivation.svg';
import { PATH } from 'constants/path';
// import ReviewModal from './components/ReviewModal';
import useFetchAuditDetailData from './hooks/useFetchAuditDetailData';
import { transferFormValue } from 'utils/channel';
import { StepValue } from 'pages/CreateUniProfilePage/types';
import Detail from './components/Detail';
// import useFetchReviewsData from './hooks/useFetchReviewsData';
// import StatusTag from 'components/StatusTag';
import ChannelAuditStatusTag from 'components/ChannelAuditStatusTag';
import UniprofileAuditStatusTag from 'components/UniprofileAuditStatusTag';
import { NoticeType } from 'antd/es/message/interface';
import globalFormsEditStatusStore from 'store/ChannelApplicationProvider/FormsEditStatus';
import { IProfileFormSubmit } from 'types/channelApplicationProvider';
import { EType } from '../ProviderPage';
import { baseURL } from 'api';
import { getUrlParam } from 'utils/common';
import { EAuditStatus, EChanelAuditStatus } from 'types/operation';
import useFetchAuditDetailSnapshotData from './hooks/useFetchAuditDetailSnapshotData';
import { getShadowDataFromTwoData } from 'data/provider';
// import { useRequest } from 'ahooks';
// import dayjs from 'dayjs';
// import { getProviderNameDisplay } from 'utils/provider';
// import { downloadFileWithBlob } from 'utils/file';
// import { getUserToken } from 'utils/localstore';
import ProfileStore from 'store/Profile';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import dayjs from 'utils/dayjs';
import DateSelect from 'pages/PPAOnboardingFinishPage/components/DateSelect';
import { EProviderListStatus } from 'types/provider';
import { sources } from 'webpack';

type ISubmitData = Partial<IProfileFormSubmit>;
export interface FormInterface {
    gmail: string;
    gmailPassword: string;
}

const getAllKeys = (obj: any): string[] => {
    let keys: string[] = [];

    try {
        for (const key in obj) {
            //@ts-nocheck
            // eslint-disable-next-line no-prototype-builtins
            if (obj.hasOwnProperty(key)) {
                // 添加条件语句以过滤掉原型链上的属性
                keys.push(key);
                if (typeof obj[key] === 'object') {
                    keys = keys.concat(getAllKeys(obj[key]));
                }
            }
        }
    } catch (e) {
        console.error(e);
    }

    return keys;
};

const Page = () => {
    const { id, pid } = useParams();
    const updated: boolean = !!getUrlParam('updated');
    const channelName = decodeURIComponent(getUrlParam('channelName') || '');
    const channelId = id ? parseInt(id, 10) : 0;
    const providerId = pid ? parseInt(pid, 10) : 0;
    const navigate = useNavigate();
    const [messageApi, messageContextHolder] = message.useMessage();
    const [saveLoading, setSaveLoading] = useState<boolean>(false);
    // const [showReviewModal, setShowReviewModal] = useState(false);
    const [showOnHold, setShowOnHold] = useState(false);
    const [showApprove, setShowApprove] = useState(false);
    const [showListed, setShowListed] = useState(false);
    const [showWaitApproveModal, setShowWaitApproveModal] = useState(false);
    const [, setGloalEditStatus] = globalFormsEditStatusStore.useStore();
    const isUniprofileDetail = channelId === -1;

    // const [form] = Form.useForm<FormInterface>();
    // const [getUser] = ProviderStore.useStore();
    // const user = getUser('data');

    const [hasSettleAll, setHasSettleAll] = useState(false);
    const [settling, setSettling] = useState(false);
    const [syncingEhr, setSyncingEhr] = useState(false);

    const {
        data: auditDetailData,
        loading,
        refetch,
    } = useFetchAuditDetailData({
        channelId,
        providerId,
    });
    const isPPA = auditDetailData?.source === 'K'; // E是ppv
    const {
        data: auditDetailSnapshotData,
        snapshotLoading,
        refetchSnapshot,
    } = useFetchAuditDetailSnapshotData(updated ? providerId : undefined);
    const dataAfterChange =
        updated && !hasSettleAll ? getShadowDataFromTwoData(auditDetailData, auditDetailSnapshotData) : undefined;
    const useData =
        updated && auditDetailSnapshotData && dataAfterChange && auditDetailData && !hasSettleAll
            ? dataAfterChange
            : auditDetailData;

    const [finishEhrInit, setFinishEhrInit] = useState(false);
    const [getProfileStore, setProfileStore] = ProfileStore.useStore();

    const allKeys: string[] = getAllKeys(useData);
    const hasNew = !!allKeys.find((item) => item.includes('New'));

    const showNewBtn = hasNew && updated && auditDetailSnapshotData && !hasSettleAll;
    const showAlert = updated && auditDetailSnapshotData && !hasSettleAll;

    const detailRef = useRef<any>();
    // const { reviews, refetchReviews } = useFetchReviewsData(channelId, providerId);
    const { profile } = useData;
    const { auditStatus, updateStatus } = profile;
    const [showDisqualifyModal, setShowDisqualifyModal] = useState(false);
    const [disqualifyReason, setDisqualifyReason] = useState<string[]>([]);
    const [disqualifyReasonOther, setDisqualifyReasonOther] = useState<string>('');

    const [showConfirmApproveModal, setShowConfirmApproveModal] = React.useState(false);
    const [goLiveTime, setGoLiveTime] = React.useState<number>(dayjs().add(48, 'hours').valueOf());
    const [confirmOption, setConfirmOption] = React.useState<'approve' | 'email'>('approve');
    const [dateSelectOpen, setDateSelectOpen] = React.useState<boolean>(false);

    const [isSendingEmail, setIsSendingEmail] = React.useState(false);

    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const handleDateConfirm = async (date: dayjs.Dayjs) => {
        setConfirmLoading(true);
        const res = await updateLaunchTime(date.utc().format('YYYY-MM-DDTHH:mm:ss[Z]'), providerId);
        setConfirmLoading(false);
        if (!res.error) {
            setGoLiveTime(date.valueOf());
            setDateSelectOpen(false);
        }
    };

    const showOtherInput = disqualifyReason.includes('other');

    useEffect(() => {
        if (auditDetailData && auditDetailData.expectLaunchTime) {
            setGoLiveTime(dayjs(auditDetailData.expectLaunchTime).valueOf());
        }
    }, [auditDetailData]);

    useEffect(() => {
        return () => setGloalEditStatus('globalEditStatus', false);
    }, []);

    useEffect(() => {
        const check = async () => {
            const result = await getEhrInitStatus(providerId);
            if (!result.error) {
                const status = result.data?.data;
                if (status?.ehrSetUpCompleted) {
                    setFinishEhrInit(true);
                }
            }
        };
        if (providerId) {
            check();
        }
    }, [providerId]);

    const handleMessageContent = useCallback(
        (type: NoticeType, content: string) => {
            messageApi.open({
                type,
                content,
            });
        },
        [messageApi],
    );

    // const handleAddReviewsSuccess = useCallback(() => {
    //     refetchReviews();
    //     setShowReviewModal(false);
    // }, [refetchReviews]);

    // const handleShowReviewModal = useCallback(async () => {
    //     setShowReviewModal(true);
    // }, []);

    const handleChangeConfirm = async () => {
        setHasSettleAll(true);
        setSettling(true);
        await refetch();
        await syncSnapshot(providerId);
        setSettling(false);
    };

    // const base64ToBlob = useCallback((base64: string, contentType: string) => {
    //     const byteCharacters = atob(base64);
    //     const byteNumbers = new Array(byteCharacters.length);
    //     for (let i = 0; i < byteCharacters.length; i++) {
    //         byteNumbers[i] = byteCharacters.charCodeAt(i);
    //     }
    //     const byteArray = new Uint8Array(byteNumbers);
    //     return new Blob([byteArray], { type: contentType });
    // }, []);

    // const downloadFile = useCallback(async () => {
    //     if (auditDetailData && auditDetailData.profile) {
    //         try {
    //             const response = await exportProviderByPorivderId(providerId);
    //             if (response && !response.error && response.data) {
    //                 const binaryString = JSON.parse(JSON.stringify(response.data));
    //                 const byteArray = new Uint8Array(binaryString.length);
    //                 for (let i = 0; i < binaryString.length; i++) {
    //                     byteArray[i] = binaryString.charCodeAt(i);
    //                 }
    //                 // const blob = base64ToBlob(response.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    //                 const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //                 const fileName = `${getProviderNameDisplay({
    //                     firstName: auditDetailData.profile?.firstName,
    //                     lastName: auditDetailData.profile?.lastName,
    //                     middleName: auditDetailData.profile?.middleName,
    //                 })}_${dayjs().format('MM/DD/YYYY')}.xlsx`;
    //                 const downloadUrl = window.URL.createObjectURL(blob);

    //                 // 创建一个隐藏的 <a> 元素
    //                 const a = document.createElement('a');
    //                 a.style.display = 'none';
    //                 a.href = downloadUrl;
    //                 a.download = fileName;

    //                 // 将 <a> 元素添加到文档中并触发点击事件以启动下载
    //                 document.body.appendChild(a);
    //                 a.click();

    //                 // 清理
    //                 window.URL.revokeObjectURL(downloadUrl);
    //                 document.body.removeChild(a);
    //                 // const csvData = response.data;
    //                 // const fileName = `${getProviderNameDisplay({
    //                 //     firstName: auditDetailData.profile?.firstName,
    //                 //     lastName: auditDetailData.profile?.lastName,
    //                 //     middleName: auditDetailData.profile?.middleName,
    //                 // })}_${dayjs().format('MM/DD/YYYY')}.xlsx`;

    //                 // downloadFileWithBlob(csvData, fileName);
    //             } else {
    //                 message.error(response?.error);
    //             }
    //         } catch (e) {
    //             console.error(e);
    //         }
    //     }
    // }, [providerId, auditDetailData, base64ToBlob]);

    // const { loading: exportLoading, run: handleHoldOn } = useRequest(downloadFile, {
    //     manual: true,
    // });

    const handleHoldOn = useCallback(async () => {
        const url = `${baseURL}admin-server/provider/profile/export?providerId=${providerId}`;

        // const newUrl = [url, `token=${getUserToken()}`].join('?');

        window.location.href = url;
    }, [providerId]);

    const handleApprove = useCallback(async () => {
        setSaveLoading(true);

        const updateRes = await channelWaitingApproval(channelId, providerId);

        await refetch();
        if (!updateRes?.error) {
            setShowWaitApproveModal(false);
        } else {
            handleMessageContent('error', 'Application approved failed!');
            console.error(updateRes);
        }

        setSaveLoading(false);
    }, [channelId, handleMessageContent, providerId, refetch]);

    // const handleGoLive = useCallback(async () => {
    //     setSaveLoading(true);

    //     const goliveRes = await providerChannelAuditGoLive({
    //         channelId,
    //         providerId,
    //     });

    //     await refetch();

    //     if (!goliveRes.error) {
    //         setShowListed(true);
    //     } else {
    //         handleMessageContent('error', 'Application go-live failed!');
    //         console.error(goliveRes);
    //     }
    //     setSaveLoading(false);
    // }, [channelId, handleMessageContent, providerId, refetch]);

    const onSubmit = useCallback(
        async (formValue: ISubmitData, step: StepValue) => {
            setSaveLoading(true);

            const submitData = {
                providerId: profile?.id,
                channelId,
                ...transferFormValue(formValue, step),
                step: step.toLocaleUpperCase(),
            };

            const submitRes = await updateProviderChannelInfo(submitData);

            await refetch();

            if (!submitRes?.error) {
                detailRef.current?.setStepEditStatus?.(false, step);
            } else {
                handleMessageContent('error', submitRes.error);
                console.error(submitRes);
            }

            setSaveLoading(false);
        },
        [channelId, handleMessageContent, profile, refetch],
    );

    const handleUniprofileApprove = async (pass: boolean, passSetGoLiveTime?: boolean) => {
        if (pass) {
            if (passSetGoLiveTime) {
                const res = await updateUniprofileAuditStatus({
                    providerId,
                    passed: pass,
                });

                if (!res?.error) {
                    await refetch();
                } else {
                    handleMessageContent('error', res.error);
                }
            } else {
                const res1 = await updateLaunchTime(
                    dayjs(goLiveTime).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
                    providerId,
                );
                if (!res1.error) {
                    const res = await updateUniprofileAuditStatus({
                        providerId,
                        passed: pass,
                    });

                    if (!res?.error) {
                        await refetch();
                    } else {
                        handleMessageContent('error', res.error);
                    }
                } else {
                    handleMessageContent('error', res1.error);
                }
            }
        } else {
            const reason = disqualifyReason.filter((item) => item !== 'other');
            if (disqualifyReasonOther) {
                reason.push(disqualifyReasonOther);
            }
            const res = await updateUniprofileAuditStatus({
                providerId,
                passed: pass,
                rejectReason: reason?.join(','),
            });

            if (!res?.error) {
                await refetch();
            } else {
                handleMessageContent('error', res.error);
            }
        }
        setDisqualifyReason([]);
        setDisqualifyReasonOther('');
        setShowDisqualifyModal(false);
        setShowConfirmApproveModal(false);
    };

    const handleUniprofileConfirmApprove = async () => {
        setShowConfirmApproveModal(true);
    };
    const handleUniprofileDisqualify = async () => {
        setShowDisqualifyModal(true);
    };

    const handleClickEmail = async () => {
        setIsSendingEmail(true);
        const res = await emailProvider(providerId);
        if (!res.error) {
            message.success('Email sent successfully to provider.');
            setShowConfirmApproveModal(false);
        } else {
            message.error(res.error);
        }
        setIsSendingEmail(false);
    };

    // export enum EChanelAuditStatus {
    //     UNIPROFILE_NEEDED = 'uniprofile-needed',
    //     UPLOAD_DATA = 'upload-data',
    //     WAITING_APPROVE = 'waiting-approve',
    //     FAILED = 'failed',
    //     APPROVED = 'approved',
    // }

    // export enum EAuditStatus {
    //     FOLLOW_UP = 'follow-up',
    //     PENDING = 'pending',
    //     APPROVED = 'approved',
    //     REJECTED = 'rejected',
    // }

    const handleSync = async () => {
        setProfileStore('isSyncingEhr', true);
        setSyncingEhr(true);
        const result = await syncEhr(providerId);
        if (!result.error) {
            message.success('Sync with EHR successfully');
        }
        setSyncingEhr(false);
        setProfileStore('isSyncingEhr', false);
    };

    const renderButtons = useMemo(() => {
        if (isUniprofileDetail) {
            const showDownload =
                auditStatus === EAuditStatus.APPROVED ||
                auditStatus === EAuditStatus.REJECTED ||
                auditStatus === EAuditStatus.PENDING;
            const showDisqualify = auditStatus === EAuditStatus.PENDING;
            const showApproveBtn = auditStatus === EAuditStatus.PENDING;
            const showContact = auditStatus === EAuditStatus.FOLLOW_UP;
            const showSync = auditStatus === EAuditStatus.APPROVED;
            return (
                <div className={s.right}>
                    {showSync && finishEhrInit && !isPPA && (
                        <Button
                            type="primary"
                            ghost
                            loading={syncingEhr}
                            onClick={handleSync}
                            className={s.btnWithLink}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <path
                                    d="M2.66699 2.66797V6.0013H3.05467M13.2924 7.33464C12.9643 4.70376 10.7201 2.66797 8.00033 2.66797C5.76207 2.66797 3.84585 4.04675 3.05467 6.0013M3.05467 6.0013H6.00033M13.3337 13.3346V10.0013H12.946M12.946 10.0013C12.1548 11.9559 10.2386 13.3346 8.00033 13.3346C5.28058 13.3346 3.03632 11.2988 2.70825 8.66797M12.946 10.0013H10.0003"
                                    stroke="#00816B"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            Sync with EHR
                        </Button>
                    )}
                    {showDownload && (
                        <Button
                            type="primary"
                            ghost
                            onClick={handleHoldOn}
                            // loading={exportLoading}
                        >
                            Download UniProfile in Excel
                        </Button>
                    )}
                    {showDisqualify && (
                        <Button type="primary" danger onClick={() => handleUniprofileDisqualify()}>
                            Disqualify
                        </Button>
                    )}

                    {showApproveBtn && (
                        <Button
                            type="primary"
                            onClick={() => {
                                const needConfirm =
                                    auditDetailData?.listingStatus === EProviderListStatus.PR &&
                                    auditDetailData?.source === 'K';
                                if (needConfirm) {
                                    handleUniprofileConfirmApprove();
                                } else {
                                    handleUniprofileApprove(true, true);
                                }
                            }}
                        >
                            Approve
                        </Button>
                    )}
                    {showContact && (
                        <Button type="primary" className={s.btnWithLink}>
                            <a href={`mailto:${profile.email}`}>Contact provider</a>
                        </Button>
                    )}
                </div>
            );
        } else {
            //channel
            if (auditStatus === EChanelAuditStatus.APPROVED) {
                return (
                    <div className={s.right}>
                        <Button
                            type="primary"
                            ghost
                            onClick={handleHoldOn}
                            // loading={exportLoading}
                        >
                            Download UniProfile in Excel
                        </Button>
                    </div>
                );
            }
            if (auditStatus === EChanelAuditStatus.UPLOAD_DATA) {
                return (
                    <div className={s.right}>
                        <Button
                            type="primary"
                            ghost
                            onClick={handleHoldOn}
                            // loading={exportLoading}
                        >
                            Download UniProfile in Excel
                        </Button>
                        <Button type="primary" onClick={() => setShowWaitApproveModal(true)}>
                            Update status to Awaiting approval
                        </Button>
                    </div>
                );
            }
        }

        return null;
    }, [
        isUniprofileDetail,
        auditStatus,
        handleHoldOn,
        handleUniprofileApprove,
        profile.email,
        syncingEhr,
        finishEhrInit,
    ]);

    const platformUrl = `https://dev.d3n71p7v2xu531.amplifyapp.com/provider/${profile.firstName}-${profile.lastName}/${profile.id}`;
    const channelNameTail = channelName ? ` - ${decodeURIComponent(channelName)}` : '';
    const providerNameDisplay =
        profile.firstName || profile.lastName ? `${profile?.firstName} ${profile?.lastName}` : profile?.email;
    const showSync = isUniprofileDetail && finishEhrInit && auditStatus === EAuditStatus.APPROVED;
    const [changeInx, setChangeInx] = React.useState(0);

    const checkChange = () => {
        //@ts-ignore
        const changeElements: any[] = document.getElementsByClassName('changed') as any[];
        if (!changeElements || changeElements.length === 0) {
            return;
        }
        let goInx = changeInx;
        if (changeInx >= changeElements.length) {
            goInx = 0;
        }
        for (let i = 0; i < changeElements.length; i++) {
            if (i === goInx) {
                changeElements[i].style.borderWidth = '2px';
                changeElements[i].style.fontWeight = 'bolder';
                changeElements[i].scrollIntoView({
                    behavior: 'smooth', // 滚动行为可以是 "auto", "instant", 或 "smooth"
                    block: 'center', // 在视口的顶部滚动元素到视口中
                });
            } else {
                changeElements[i].style.borderWidth = '1px';
                changeElements[i].style.fontWeight = 'normal';
            }
        }
        setChangeInx(goInx + 1);
    };

    return (
        <div className={s.wrap}>
            {messageContextHolder}
            <Spin spinning={loading || saveLoading}>
                <div className={s.header}>
                    <div className={s.headerInner}>
                        <div className={s.left}>
                            <div
                                onClick={() => {
                                    !isUniprofileDetail
                                        ? navigate(`${PATH.OPERATION}/${PATH.CHANNEL}?type=application`)
                                        : navigate(`${PATH.OPERATION}/${PATH.PROVIDER}?type=${EType.UNI_PROFILE}`);
                                }}
                                className={s.leftTop}
                            >
                                <span className={s.leftTopHome}>
                                    <ArrowLeftOutlined />
                                </span>
                                <span className={s.link}>
                                    {isUniprofileDetail ? 'Back to Uniprofile' : 'Back to Channel listing'}
                                </span>
                            </div>
                            <h1 className={s.leftBtm}>
                                <span className={s.title}>{`${providerNameDisplay}${channelNameTail}`}</span>
                                <span className={s.tag}>
                                    {isUniprofileDetail ? (
                                        <UniprofileAuditStatusTag status={auditStatus} />
                                    ) : (
                                        <ChannelAuditStatusTag status={auditStatus} />
                                    )}
                                </span>
                            </h1>
                        </div>
                        {renderButtons}
                    </div>
                </div>
                {showAlert && (
                    <div className={s.alertWrap}>
                        <Alert
                            message={<div style={{ fontSize: '24', fontWeight: 'bold' }}>Infomation update</div>}
                            description={
                                <div className={s.info}>
                                    {/* <p>Provider has updated some information of uniprofile, we will highlight some key info for you with red color.</p>
                                    <p>For example: Credentials: <b>DNP, A-GNP-C</b> <span style={{ color: 'red', fontWeight: 'bold' }}>A-GNP-C</span> </p>
                                    <p>This means the provider has changed <span style={{ color: 'red', fontWeight: 'bold' }}>A-GNP-C</span> to <b>DNP, A-GNP-C</b></p>
                                    <p><b>Other changes still need you to check and sync to channels.</b></p> */}
                                    We&apos;ve highlighted the provider&apos;s <b>previous</b> UniProfile information in
                                    blue. Please review and confirm all changes and sync to channels. After you&apos;ve
                                    moved all updates into channels, click &quot;Mark as resolved&quot; to clear all
                                    highlights.
                                </div>
                            }
                            type="info"
                            action={
                                <Space direction="vertical">
                                    <Button loading={settling} onClick={handleChangeConfirm} type="primary">
                                        Mark as resolved
                                    </Button>
                                </Space>
                            }
                        />
                    </div>
                )}
                <Detail
                    providerId={providerId}
                    ref={detailRef}
                    channelId={channelId}
                    formData={useData}
                    onSubmit={onSubmit}
                    // showSyncButton={showSync}
                    // onClickSync={handleSync}
                    refetch={refetch}
                    // onShowReviewModal={handleShowReviewModal}
                    // reviews={reviews}
                    onShowMessage={handleMessageContent}
                    onApprove={handleApprove}
                />
                <Modal
                    title="Application on-hold with feedback"
                    closable
                    className={commonS.modalFixHeightWrap}
                    width="660px"
                    destroyOnClose
                    onCancel={() => {
                        setShowOnHold(false);
                    }}
                    footer={
                        <div className={s.footerWrap}>
                            <Button
                                onClick={() => {
                                    setShowOnHold(false);
                                    navigate(`${PATH.OPERATION}/${PATH.CHANNEL}`);
                                }}
                            >
                                Back to Channels
                            </Button>
                            <Button
                                type="primary"
                                onClick={() => {
                                    setShowOnHold(false);
                                    window.open(`mailto:${profile?.email}`);
                                }}
                            >
                                Open Gmail
                            </Button>
                        </div>
                    }
                    open={showOnHold}
                >
                    <div className={s.onHoldWrap}>
                        <div className={s.imgWrap}>
                            <img src={OnHoldImg} />
                        </div>
                        <div className={s.title}>
                            Send feedback to provider {profile?.firstName}, {profile?.lastName}
                        </div>
                        <div className={s.subTitle}>
                            Please email the provider to explain application on-hold reasons in detail.
                        </div>
                    </div>
                </Modal>
                <Modal
                    title="Application approve"
                    closable
                    className={commonS.modalFixHeightWrap}
                    width="660px"
                    destroyOnClose
                    footer={
                        <div className={s.footerWrap}>
                            <Button
                                onClick={() => {
                                    setShowApprove(false);
                                    navigate(`${PATH.OPERATION}/${PATH.CHANNEL}`);
                                }}
                            >
                                Back to Channels
                            </Button>
                        </div>
                    }
                    onCancel={() => {
                        setShowApprove(false);
                    }}
                    open={showApprove}
                >
                    <div className={s.onHoldWrap}>
                        <div className={s.imgWrap}>
                            <img src={ApproveImg} />
                        </div>
                        <div className={s.title}>
                            Provider {profile?.firstName}, {profile?.lastName}’s channel integration application has
                            been approved
                        </div>
                        <div className={s.subTitle}>
                            Please ensure the provider’s EHR is configured properly and the Provider Profile Pages in
                            Marketplace are alive. After the configuration, please update the channel integration status
                            to Go-live.
                        </div>
                    </div>
                </Modal>
                <Modal
                    title="Update status to Awaiting approval"
                    closable
                    className={commonS.modalFixHeightWrap}
                    width="660px"
                    destroyOnClose
                    okText="Yes, I confirm"
                    cancelText="No, still in progress"
                    onOk={handleApprove}
                    onCancel={() => setShowWaitApproveModal(false)}
                    open={showWaitApproveModal}
                >
                    <p>Have you added the provider&apos;s information to the Channel correctly? </p>
                </Modal>
                <Modal
                    title="Application go live"
                    closable
                    className={commonS.modalFixHeightWrap}
                    width="660px"
                    destroyOnClose
                    footer={
                        <div className={s.footerWrap}>
                            <Button
                                onClick={() => {
                                    setShowApprove(false);
                                    navigate(`${PATH.OPERATION}/${PATH.CHANNEL}`);
                                }}
                            >
                                Back to Channels
                            </Button>
                        </div>
                    }
                    onCancel={() => {
                        setShowApprove(false);
                    }}
                    open={showListed}
                >
                    <div className={s.onHoldWrap}>
                        <div className={s.imgWrap}>
                            <img src={Motivation} />
                        </div>
                        <div className={s.title}>
                            Provider {profile?.firstName}, {profile?.lastName} has been successfully listed
                        </div>
                        <div className={s.subTitle}>
                            Provider is ready to be booked. <a href={platformUrl}>View provider profile</a>
                        </div>
                    </div>
                </Modal>
                {
                    // showReviewModal &&
                    // <ReviewModal
                    //     channelId={channelId}
                    //     providerId={providerId}
                    //     initValue={reviews}
                    //     onSuccess={handleAddReviewsSuccess}
                    //     onCancel={() => { setShowReviewModal(false); }}
                    // />
                }
                <Modal
                    title="Disqualify provider"
                    closable
                    className={commonS.modalFixHeightWrap}
                    width="660px"
                    destroyOnClose
                    footer={
                        <div className={s.footerWrap}>
                            <Button
                                onClick={() => {
                                    setShowDisqualifyModal(false);
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                className={s.danger}
                                type="primary"
                                danger
                                onClick={() => {
                                    handleUniprofileApprove(false);
                                }}
                            >
                                Disqualify
                            </Button>
                        </div>
                    }
                    onCancel={() => {
                        setShowDisqualifyModal(false);
                    }}
                    open={showDisqualifyModal}
                >
                    <div className={s.disWrap}>
                        <div className={s.disTitle}>
                            Please select a reason for disqualifying this provider’s profile.
                        </div>
                        <div className={s.disReason}>
                            <Checkbox.Group
                                onChange={(v: CheckboxValueType[]) => {
                                    setDisqualifyReason(v as string[]);
                                }}
                                value={disqualifyReason}
                            >
                                <Row>
                                    <Col span={24} style={{ marginBottom: '8px' }}>
                                        <Checkbox value="Medical license expired / invalid">
                                            Medical license expired / invalid
                                        </Checkbox>
                                    </Col>
                                    <Col span={24} style={{ marginBottom: '8px' }}>
                                        <Checkbox value="Government-issued ID expired / invalid">
                                            Government-issued ID expired / invalid
                                        </Checkbox>
                                    </Col>
                                    <Col span={24} style={{ marginBottom: '8px' }}>
                                        <Checkbox value="Insurance plan not specified">
                                            Insurance plan not specified
                                        </Checkbox>
                                    </Col>
                                    <Col span={24} style={{ marginBottom: '8px' }}>
                                        <Checkbox value="other">
                                            Other reasons <span style={{ color: '#6B7280' }}>(need to input)</span>
                                        </Checkbox>
                                    </Col>
                                </Row>
                            </Checkbox.Group>
                        </div>
                        {showOtherInput && (
                            <div className={s.otherInput}>
                                <Input.TextArea
                                    rows={4}
                                    style={{ marginLeft: '24px', width: '400px' }}
                                    placeholder="Specify your reason for disqualifying this provider..."
                                    onChange={(e) => setDisqualifyReasonOther(e.target.value)}
                                />
                            </div>
                        )}
                    </div>
                </Modal>

                <Modal
                    title="Confirm provider approval"
                    closable
                    className={commonS.modalFixHeightWrap}
                    width="560px"
                    destroyOnClose
                    footer={
                        confirmOption === 'email' ? (
                            <div className={s.footerWrap}>
                                <Button
                                    onClick={() => {
                                        setShowConfirmApproveModal(false);
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={() => {
                                        // window.open(`mailto:${profile?.email}`);
                                        handleClickEmail();
                                    }}
                                    type="primary"
                                    loading={isSendingEmail}
                                >
                                    Send
                                </Button>
                            </div>
                        ) : (
                            <div className={s.footerWrap}>
                                <Button
                                    onClick={() => {
                                        setShowConfirmApproveModal(false);
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className={s.danger}
                                    type="primary"
                                    onClick={() => {
                                        handleUniprofileApprove(true);
                                    }}
                                >
                                    Approve
                                </Button>
                            </div>
                        )
                    }
                    onCancel={() => {
                        setConfirmOption('approve');
                        setShowConfirmApproveModal(false);
                    }}
                    open={showConfirmApproveModal}
                >
                    <div className={s.appWrap}>
                        <div className={s.appTitle}>
                            Provider ({profile?.firstName} {profile?.lastName}) has set the expected go-live date as
                            August 27, 2025. Once approved, the profile will automatically become active on that date.
                        </div>
                        <div
                            onClick={() => {
                                setConfirmOption('approve');
                            }}
                            className={`${s.appContent} ${confirmOption === 'approve' ? s.appContentCheck : ''}`}
                        >
                            <div className={s.appHeader}>
                                <div className={s.appLeft}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M17.55 9.175L21.075 5.625C21.275 5.425 21.5127 5.325 21.788 5.325C22.0633 5.325 22.3007 5.425 22.5 5.625C22.6993 5.825 22.7993 6.06267 22.8 6.338C22.8007 6.61333 22.7007 6.85067 22.5 7.05L18.25 11.3C18.05 11.5 17.8167 11.6 17.55 11.6C17.2833 11.6 17.05 11.5 16.85 11.3L14.725 9.175C14.525 8.975 14.425 8.73767 14.425 8.463C14.425 8.18833 14.525 7.95067 14.725 7.75C14.925 7.54933 15.1583 7.44933 15.425 7.45C15.6917 7.45067 15.925 7.55067 16.125 7.75L17.55 9.175ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM1 18V17.2C1 16.6333 1.146 16.1127 1.438 15.638C1.73 15.1633 2.11733 14.8007 2.6 14.55C3.63333 14.0333 4.68333 13.646 5.75 13.388C6.81667 13.13 7.9 13.0007 9 13C10.1 12.9993 11.1833 13.1287 12.25 13.388C13.3167 13.6473 14.3667 14.0347 15.4 14.55C15.8833 14.8 16.271 15.1627 16.563 15.638C16.855 16.1133 17.0007 16.634 17 17.2V18C17 18.55 16.8043 19.021 16.413 19.413C16.0217 19.805 15.5507 20.0007 15 20H3C2.45 20 1.97933 19.8043 1.588 19.413C1.19667 19.0217 1.00067 18.5507 1 18ZM3 18H15V17.2C15 17.0167 14.9543 16.85 14.863 16.7C14.7717 16.55 14.6507 16.4333 14.5 16.35C13.6 15.9 12.6917 15.5627 11.775 15.338C10.8583 15.1133 9.93333 15.0007 9 15C8.06667 14.9993 7.14167 15.112 6.225 15.338C5.30833 15.564 4.4 15.9013 3.5 16.35C3.35 16.4333 3.229 16.55 3.137 16.7C3.045 16.85 2.99933 17.0167 3 17.2V18ZM9 10C9.55 10 10.021 9.80433 10.413 9.413C10.805 9.02167 11.0007 8.55067 11 8C10.9993 7.44933 10.8037 6.97867 10.413 6.588C10.0223 6.19733 9.55133 6.00133 9 6C8.44867 5.99867 7.978 6.19467 7.588 6.588C7.198 6.98133 7.002 7.452 7 8C6.998 8.548 7.194 9.019 7.588 9.413C7.982 9.807 8.45267 10.0027 9 10Z"
                                            fill="#374151"
                                        />
                                    </svg>
                                    Approve this provider
                                </div>
                                <div className={s.appRight}>
                                    {confirmOption === 'approve' && (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M11.9984 21.5984C17.3004 21.5984 21.5984 17.3004 21.5984 11.9984C21.5984 6.6965 17.3004 2.39844 11.9984 2.39844C6.6965 2.39844 2.39844 6.6965 2.39844 11.9984C2.39844 17.3004 6.6965 21.5984 11.9984 21.5984ZM16.447 10.447C16.9156 9.97834 16.9156 9.21854 16.447 8.74991C15.9783 8.28128 15.2185 8.28128 14.7499 8.74991L10.7984 12.7014L9.24696 11.1499C8.77833 10.6813 8.01854 10.6813 7.54991 11.1499C7.08128 11.6185 7.08128 12.3783 7.54991 12.847L9.94991 15.247C10.4185 15.7156 11.1783 15.7156 11.647 15.247L16.447 10.447Z"
                                                fill="#00816B"
                                            />
                                        </svg>
                                    )}
                                </div>
                            </div>
                            <div className={s.info}>
                                <div className={s.in1}>Expected go-live date</div>
                                <div className={s.in2}>{dayjs(goLiveTime).format('dddd, MMM D, YYYY')}</div>
                                <div
                                    className={s.in3}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setDateSelectOpen(true);
                                    }}
                                >
                                    Reschedule date
                                </div>
                            </div>
                        </div>

                        <div
                            onClick={() => {
                                setConfirmOption('email');
                            }}
                            className={`${s.appContent} ${confirmOption === 'email' ? s.appContentCheck : ''}`}
                        >
                            <div className={s.appHeader}>
                                <div className={s.appLeft}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M4 5H20C20.55 5 21 5.45 21 6V18C21 18.55 20.55 19 20 19H4C3.45 19 3 18.55 3 18V6C3 5.45 3.45 5 4 5Z"
                                            stroke="#374151"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M3 6.5L12 12L21 6.5"
                                            stroke="#374151"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    Schedule a smart follow-up email
                                </div>
                                <div className={s.appRight}>
                                    {confirmOption === 'email' && (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M11.9984 21.5984C17.3004 21.5984 21.5984 17.3004 21.5984 11.9984C21.5984 6.6965 17.3004 2.39844 11.9984 2.39844C6.6965 2.39844 2.39844 6.6965 2.39844 11.9984C2.39844 17.3004 6.6965 21.5984 11.9984 21.5984ZM16.447 10.447C16.9156 9.97834 16.9156 9.21854 16.447 8.74991C15.9783 8.28128 15.2185 8.28128 14.7499 8.74991L10.7984 12.7014L9.24696 11.1499C8.77833 10.6813 8.01854 10.6813 7.54991 11.1499C7.08128 11.6185 7.08128 12.3783 7.54991 12.847L9.94991 15.247C10.4185 15.7156 11.1783 15.7156 11.647 15.247L16.447 10.447Z"
                                                fill="#00816B"
                                            />
                                        </svg>
                                    )}
                                </div>
                            </div>
                            <div className={s.info}>
                                <div className={s.in1}>
                                    Want them active sooner? Email the provider to ask about starting earlier so they
                                    can begin receiving bookings sooner.
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <DateSelect
                    open={dateSelectOpen}
                    onCancel={() => {
                        setDateSelectOpen(false);
                    }}
                    onConfirm={handleDateConfirm}
                    confirmLoading={confirmLoading}
                />
            </Spin>
            {showNewBtn && (
                <div className={s.change}>
                    <Button onClick={checkChange} id="checkChange" type="primary" className={s.change}>
                        <span>Next</span>
                        <span>Changed</span>
                    </Button>
                </div>
            )}
        </div>
    );
};

export default Page;
